import AllergyRefReaction from '../Classes/AllergyRefReaction'
import { AllergyLinkReactionForm } from '../Type/AllergyLinkReactionForm'
import { AllergyLinkReactionDto } from '../Type/AllergyLinkReactionDto'
import { Nullable } from '@internal-libraries/kheops-ui-lib'

export class AllergyLinkReaction {
    public constructor(
        public refReactionId: number,
        public allergyFoodId: Nullable<number>,
        public id?: number,
        public isActive?: boolean,
        public _refLinkedReaction?: AllergyRefReaction,
    ) {}

    public formateItemToFormData(): AllergyLinkReactionForm {
        return {
            link_allergy_reaction_id: this.id,
            allergy_food_id: this.allergyFoodId ?? undefined,
            ref_reaction_id: this.refReactionId,
            is_active: this.isActive,
        }
    }

    public toDto(): AllergyLinkReactionDto {
        return {
            allergy_food_id: this.allergyFoodId,
            ref_reaction_id: this.refReactionId,
            id: this.id ?? null,
            is_active: this.isActive,
        }
    }
}
